export const WIDGET_ACTION = {
  createBlankProject: 'create_blank_project',
  createRecentProject: 'create_recent_project',
  improveContent: 'improve_content',
  openTemplateGallery: 'open_template_gallery',
  openSavedTemplates: 'open_saved_templates',
  submitPrompt: 'submit_prompt',
} as const;
export type WidgetAction = (typeof WIDGET_ACTION)[keyof typeof WIDGET_ACTION];

export const QUICK_NAVIGATION_EVENT = {
  newBlankProject: 'new_blank_project',
  improveExistingContent: 'improve_existing_content',
  templateGallery: 'template_gallery',
  savedTemplates: 'saved_templates',
} as const;
export type QuickNavigationEvent =
  (typeof QUICK_NAVIGATION_EVENT)[keyof typeof QUICK_NAVIGATION_EVENT];
